module.exports = "/images/vendor/blueimp-gallery/video-play.svg?15116d1813411752ecd73aee05ffe43e";